import { intl } from './intl';

export const { t: videoListT, Message: VideoListMessage } = intl.createMessages({
    columnFile: {
        ru: 'Файл',
        en: 'File',
    },
    columnDate: {
        ru: 'Дата',
        en: 'Date',
    },
    columnProfile: {
        ru: 'Профиль',
        en: 'Profile',
    },
    columnStatus: {
        ru: 'Статус',
        en: 'Status',
    },
    columnTitle: {
        ru: 'Название',
        en: 'Title',
    },
    columnSize: {
        ru: 'Размер',
        en: 'Size',
    },
    columnSummarization: {
        ru: 'Суммаризация',
        en: 'Summarization',
    },
    columnProgress: {
        ru: 'Прогресс',
        en: 'Progress',
    },
    emptyList: {
        ru: 'Здесь пока пусто',
        en: 'Nothing here yet',
    },
    statistics: {
        ru: 'Статистика',
        en: 'Statistics',
    },
    actionDelete: {
        ru: 'Удалить',
        en: 'Delete',
    },
    actionShare: {
        ru: 'Поделиться',
        en: 'Share',
    },
    actionDownloadOriginal: {
        ru: 'Скачать оригинал',
        en: 'Download original',
    },
});
